import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import ForumRoundedIcon from "@mui/icons-material/ForumRounded";
import { fetchChannels } from "../../views/Dashboard/Messages/chatApi";
import { selectUser } from "../../features/userSlice";

const POLL_MS = 60_000;

// Header chat icon: opens /messages, with an unread badge fed by the same
// channel summary the Messages page and homepage widget use.
const MessagesButton = () => {
  const user = useSelector(selectUser);
  const location = useLocation();
  const [unread, setUnread] = useState(0);

  // Re-fetches on navigation as well as on the interval: reading messages
  // happens on /messages, so the badge clears promptly when you leave it.
  useEffect(() => {
    if (!user?.email) return undefined;
    let cancelled = false;
    const load = () =>
      fetchChannels(user.email)
        .then((channels) => {
          if (cancelled || !Array.isArray(channels)) return;
          setUnread(channels.reduce((sum, c) => sum + (c.unread || 0), 0));
        })
        .catch(() => {});
    load();
    const interval = setInterval(() => {
      if (document.visibilityState === "visible") load();
    }, POLL_MS);
    return () => {
      cancelled = true;
      clearInterval(interval);
    };
  }, [user?.email, location.pathname]);

  return (
    <Link
      to="/messages"
      aria-label={`Messages${unread ? ` (${unread} unread)` : ""}`}
      className="app-icon-btn relative"
    >
      <ForumRoundedIcon fontSize="small" />
      {unread > 0 && (
        <span className="absolute right-0.5 top-0.5 flex h-[1.1rem] min-w-[1.1rem] items-center justify-center rounded-full bg-red-500 px-1 text-[10px] font-bold text-white shadow-sm ring-2 ring-white dark:ring-slate-900">
          {unread > 9 ? "9+" : unread}
        </span>
      )}
    </Link>
  );
};

export default MessagesButton;
